import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { LOOK_TO_BOOK_HEATMAP_MAX_COLOR, LOOK_TO_BOOK_HEATMAP_MIN_COLOR } from '../../../../constants';

export const LookToBookHeatmapLegend = () => (
  <Stack direction="row" alignItems="center" gap="0.5rem">
    <Typography variant="caption" color="textSecondary">
      0%
    </Typography>

    <Box
      sx={{
        width: 160,
        height: 10,
        borderRadius: 1,
        background: `linear-gradient(to right, ${LOOK_TO_BOOK_HEATMAP_MIN_COLOR}, ${LOOK_TO_BOOK_HEATMAP_MAX_COLOR})`,
      }}
    />

    <Typography variant="caption" color="textSecondary">
      100%
    </Typography>

    <Typography variant="caption" color="textSecondary" sx={{ ml: '0.5rem' }}>
      Look-to-Book
    </Typography>
  </Stack>
);
